import React, { useEffect, useState } from "react";
import "./StartRating.css";
import MDBox from "components/MDBox";

import CreateFeedback from "Classes/Models/Requests/Appointments/CreateFeedback";
import UsersApi from "Classes/API/UsersApi";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import QRCode from "qrcode.react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

// StarRating component
const StarRating = ({ value, onChange }) => {
  const [hoveredValue, setHoveredValue] = useState(null);

  const handleMouseOver = (starValue) => {
    setHoveredValue(starValue);
  };

  const handleMouseLeave = () => {
    setHoveredValue(null);
  };

  const handleClick = (starValue) => {
    onChange(starValue);
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= (hoveredValue || value) ? "filled" : ""}`}
          onMouseOver={() => handleMouseOver(star)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(star)}
        >
          &#9733; {/* Unicode character for a star */}
        </span>
      ))}
    </div>
  );
};

const FeedbackFormAr = () => {
  // State to manage form values
  const [rating, setRating] = useState(1);
  const [description, setDescription] = useState("");
  const [patientName, setPatientName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const hideElementById = () => {
    const element = document.getElementById("TheSidenav");

    if (element) {
      element.style.display = "none";
    }
  };

  useEffect(() => {
    hideElementById();
  }, []);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const { tenantId } = useParams();
  console.log("tenantIdXXXXXXXXXXXXXXXXXXXXXXXXX", tenantId);
  const baseURL = window.location.origin;
  const redirectLink = `${baseURL}/Appointments/FeedbackForm/${tenantId}`;
  const handleSubmit = (event) => {
    event.preventDefault();

    console.log("Rating:", rating);
    console.log("Description:", description);

    console.log("s");
    let Feedback = new CreateFeedback();

    Feedback.Rate = rating;
    Feedback.description = description;
    Feedback.patientName = patientName;
    Feedback.doctorName = doctorName;
    Feedback.AccountingSessionID = 0;

    UsersApi.CreateFeedback({ tenant: tenantId, ...Feedback }).then((result) => {
      if (result.status == "Success") {
        Swal.fire("Success", "Feedback created successfully", "success");
      }
    });
  };

  return (
    <div>
      <MDBox mt={6} mb={3}>
        <div className="row">
          <div className="container">
            <div className="card">
              <div className="card-header">Feedback Form</div>
              <div className="card-body">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-8">
                          <form onSubmit={handleSubmit}>
                            {id == "0" && (
                              <div>
                                <label htmlFor="patientName">Patient Name:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Patient Name"
                                  id="patientName"
                                  value={patientName}
                                  onChange={(e) => setPatientName(e.target.value)}
                                />
                              </div>
                            )}

                            {id == "0" && (
                              <div className="mt-2">
                                <label htmlFor="doctorName">Doctor Name:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Doctor Name"
                                  id="doctorName"
                                  value={doctorName}
                                  onChange={(e) => setDoctorName(e.target.value)}
                                />
                              </div>
                            )}
                            <div>
                              <label htmlFor="rating">Rate your Experience:</label>
                              <br></br>
                              <StarRating value={rating} onChange={handleRatingChange} />
                            </div>
                            <div>
                              <label htmlFor="description">Description:</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                id="description"
                                value={description}
                                onChange={handleDescriptionChange}
                              />
                            </div>
                            <button className="btn btn-primary mt-4" type="submit">
                              Submit
                            </button>
                          </form>
                        </div>
                        <div className="col-md-4 mt-3">
                          <div className="container text-center">
                            <QRCode id="qrcode-canvas" value={redirectLink} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MDBox>
    </div>
  );
};

export default FeedbackFormAr;
